import { Divider } from "@ui-kit/Divider";

export const CatalogViewSectionDivider = () => {
	return (
		<div className="px-3">
			<Divider />
		</div>
	);
};
